export default angular.module('cian.newbuild.filter.metroService', [])
  .factory('MetroService', () => {
    const FOOT_MIN_DEFAULT = 25;
    const ONLY_FOOT_DEFAULT = null;
    let defaultsWasApplied = false;

    /**
     * @memberOf MetroService
     * @param onlyFoot
     * @param footMin
     * @return {?number}
     */
    function getFootMinValue(onlyFoot, footMin) {
      if (onlyFoot && onlyFoot.value === null) {
        // Если не указано, пешком или транспортом, то сбрасываем время
        return null;
      } else {
        // Время до метро по умолчанию
        return footMin.value.lte || FOOT_MIN_DEFAULT;
      }
    }

    /**
     * @memberOf MetroService
     * При выборе станции метро устанавливаем значения по умолчанию для способа и времени до метро
     * @param onlyFoot
     * @param footMin
     */
    function updateFootValuesOnStationSelection(onlyFoot, footMin) {
      // Применяем значения по умолчанию только один раз
      if (defaultsWasApplied) return;

      // Если пользователь выбрал способ до метро сам, то не меняем
      if (onlyFoot.value) {
        defaultsWasApplied = true;
        return;
      }

      onlyFoot.value = ONLY_FOOT_DEFAULT;
      footMin.value.lte = FOOT_MIN_DEFAULT;
      defaultsWasApplied = true;
    }

    return {
      getFootMinValue,
      updateFootValuesOnStationSelection,
      ONLY_FOOT_DEFAULT,
      FOOT_MIN_DEFAULT,
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/serp/services/metro.service.js